<template>
  <div class="main">
    <div class="main_head fx-none">
      <div class="search">
        <el-input v-model="value" placeholder="请输入产业链关键字">
          <a @click="submit" slot="suffix" class="searchBtn">
            <div class="icon"></div>
          </a>
        </el-input>
        <!-- <el-autocomplete popper-class="recommend-head-autocomplete" :value="value" @input="valueChange" :trigger-on-focus="false" :maxlength="50" placeholder="请输入产业链关键字" @keyup.enter.native="submit"
          @select="submit" size="small" :fetch-suggestions="querySearch">

        </el-autocomplete> -->
      </div>
    </div>

    <div class="fx-wrap chain-wrap el-card">
      <div class="classify-all">产业分类</div>
      <div v-for="item in realClassify" :key="item" class="classify-item" :class="{'activeClassify': item===activeClassify}" @click="filterHandle(item)">{{item}}</div>
    </div>

    <div class="fx-wrap chain-wrap">
      <div v-for="item in realList" :key="item.secId" class="chain-item" @click="clickHandle(item.secId)">
        <img src="@/assets/industryChainNew/cardBg-l.png" alt="" srcset="" class="mr-16">
        {{item.secName}}
      </div>
      <div class="fx-ps-center" style="width:100%;" v-if="!realList.length">
        <emptyBox />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  mixins: [],
  name: 'IndustryChain',
  components: {},
  data() {
    return {
      activeClassify: '全部',
      value: '',
      params: {
        pageNum: 1,
        pageSize: 10,
        word: '',
        parentId: null
      },
      loading: true,
      conditionShow: true,
      industryObj: {
        total: 0, records: [], current: 1, size: 9
      }
    }
  },
  computed: {
    isEmpty() {
      return !this.industryObj.records.length && !this.loading
    },
    ...mapState({
      industryChain: state => state.asyncRoute.industryChain,
      theClassify: state => state.asyncRoute.theClassify,
      allChainList: state => state.asyncRoute.allChainList,
    }),
    realClassify() {
      return ['全部', ...this.theClassify]
    },
    realList() {
      if (this.activeClassify === '全部') {
        return this.allChainList.filter(e => {
          const isSearch = this.value ? (e.secName.indexOf(this.value) !== -1 || this.value.indexOf(e.secName) !== -1) : true
          if (this.activeClassify === '全部') {
            return isSearch
          }
          return e.firstName === this.activeClassify && isSearch
        })
      }

      return this.industryChain[this.activeClassify].filter(e => {
        const isSearch = this.value ? (e.secName.indexOf(this.value) !== -1 || this.value.indexOf(e.secName) !== -1) : true

        return e.firstName === this.activeClassify && isSearch
      })

    }

    // classify() {
    //   return this.$route.name
    // }
  },

  mounted() {

  },

  created() {

  },

  methods: {
    submit() { },
    valueChange() { },
    querySearch() { },
    clickHandle(id) {
      this.$router.push({
        path: '/zxk/industryChain/overview',
        query: { id }
      })
    },
    filterHandle(item) {
      this.activeClassify = item

    }
  }
}
</script>
<style lang='scss' scoped>
.main_head {
  background-image: url("~@/assets/industry/header-bg.jpg");
  background-size: 100% 100%;
  padding: 36px;
  position: relative;
  border-radius: 6px;
  /deep/.el-autocomplete {
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .el-input__inner {
      // height: 40px;
      height: 44px;
      border-radius: 4px;
      padding-right: 50px;
      border: unset;
      border: none;
    }
    .el-input__suffix {
      right: 0;
    }
    .el-input__suffix .searchBtn {
      display: inline-block;
      color: #fff;
      height: 40px;
      // width: 50px;
      padding: 10px;
      text-align: center;
      border: 0;
      border-radius: 0;
      .icon {
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/gbIcon/fd_icon.svg");
        margin-top: 2px;
      }
      &:hover {
        color: #aaa;
      }
      cursor: pointer;
      i {
        margin-right: 10px;
      }
      display: inline-block;
      line-height: 40px;
      height: 100%;
      font-size: 18px;
    }
  }
  .search {
    // width: 60%;
    width: 55.76%;
    min-width: 910px;
    margin: 0 auto;
  }
  .hot-search {
    font-size: 13px;
    margin-bottom: 25px;
    text-align: center;
    margin-top: 25px;
    span {
      width: 74px;
      height: 30px;
      border-radius: 4px;
      line-height: 31px;
      text-align: center;
      display: inline-block;
      color: #2d6ee4;
      background-color: #fff;
    }
    a {
      color: #fff;
      margin-left: 35px;
    }
    a:hover {
      color: #ffe3bf;
    }
  }
}
.el-autocomplete {
  input::-webkit-input-placeholder {
    font-weight: 500;
    color: #333333;
    font-size: 13px;
  }
  input:-moz-placeholder {
    font-weight: 500;
    color: #333333;
    font-size: 13px;
  }
  input::-moz-placeholder {
    font-weight: 500;
    color: #333333;
    font-size: 13px;
  }
  input:-ms-input-placeholder {
    font-weight: 500;
    color: #333333;
    font-size: 13px;
  }
}
.chain-wrap {
  background-color: #fff;
  padding: 24px;
  margin-top: 24px;
  border-radius: 6px;
}
.classify-all {
  padding: 4px 8px;
  border-radius: 3px;
  margin-right: 4px;
}
.classify-item {
  padding: 4px 8px;
  border-radius: 3px;
  margin-right: 4px;
  cursor: pointer;
  &.activeClassify {
    background: #186bfc;
    color: #fff;
  }
  &:hover {
    background: #186bfc;

    color: #fff;
  }
}
.chain-item {
  width: 280px;
  height: 60px;
  background: #fafbfc;
  border-radius: 2px;
  border: 1px solid #e6e7ed;
  margin: 0 16px 16px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-size: 1rem;
  font-weight: 400;
  color: #86909c;
  position: relative;
  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    content: "";
    width: 48px;
    height: 48px;
    background: url("~@/assets/industryChainNew/cardBg.png");
  }
  &:hover {
    background: linear-gradient(180deg, #f4f6fa, #e4eeff);
    border: 1px solid #186bfc;
    color: #586474;
  }
}
</style>
